export const checkpoints = [
    { label: '300+', value: 0 },
    { label: '800', value: 78 },
    { label: '1000+', value: 100 },
];

export const powerCheckpoint = checkpoints[1].value;
export const photoPositions = [0, 39, 65, powerCheckpoint, 100];
export const clamp = (n, min = 0, max = 100) => Math.min(max, Math.max(min, n));

export function settleCheckpoint(value, previous) {
    // Give 800 a wider capture zone so nearby releases land on it.
    if (Math.abs(value - powerCheckpoint) <= 8) return powerCheckpoint;
    return checkpoints.find(point => Math.abs(point.value - value) <= 3)?.value ?? previous;
}

export function experienceAt(value) {
    const progress = clamp(value);
    const tier = progress >= 100 ? 2 : progress >= powerCheckpoint ? 1 : 0;
    const hours = tier === 0 ? Math.min(700, Math.round(300 + Math.max(0, progress - 3) / (powerCheckpoint - 3) * 400))
        : tier === 1 ? Math.min(999, Math.round(800 + (progress - powerCheckpoint) / (100 - powerCheckpoint) * 200)) : 1000;
    return { tier, hours, label: progress === 0 ? '300+' : tier === 2 ? '1000+' : String(hours) };
}

export function photoOpacity(value, index) {
    if (index === 0 || value >= photoPositions[index]) return 1;
    const start = index === 1 ? 8 : photoPositions[index - 1];
    const t = clamp((value - start) / (photoPositions[index] - start), 0, 1);
    // Keep the previous frame opaque underneath; fading both creates a brightness dip.
    return t * t * (3 - 2 * t);
}

export function portraitBlend(value) {
    const t = clamp(value / 8, 0, 1);
    const opening = 1 - t * t * (3 - 2 * t);
    const reveals = photoPositions.map((_, index) => photoOpacity(value, index));
    return {
        opening,
        poses: reveals.map((reveal, index) => reveal * (1 - (reveals[index + 1] ?? 0)) * (1 - opening)),
    };
}